<div class="flex items-center" mat-dialog-title>
  <mat-icon class="text-orange mr-3">warning</mat-icon>
  <h2 class="headline m-0 flex-auto">Retirer {{ data.member.fullName }} de l'équipe</h2>
  <button mat-icon-button type="button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider class="-mx-6"></mat-divider>

<mat-dialog-content class="pt-4 flex flex-col gap-4">
  <p class="m-0 body-1 text-secondary">{{ data.member.fullName }} ne pourra plus agir pour {{ data.team.name }}.</p>

  <div class="rounded border p-4 flex flex-col gap-3">
    <p class="m-0 body-2">Ce qui ne change pas</p>
    <div class="flex items-start gap-3">
      <mat-icon class="text-green flex-none">check_circle</mat-icon>
      <p class="m-0 body-1">Les {{ data.team.usages.length }} désignations de l'équipe : aucune à reprendre.</p>
    </div>
    <div class="flex items-start gap-3">
      <mat-icon class="text-green flex-none">check_circle</mat-icon>
      <p class="m-0 body-1">Les {{ pendingActions }} actions en cours restent à l'équipe.</p>
    </div>
    <div class="flex items-start gap-3">
      <mat-icon class="text-green flex-none">check_circle</mat-icon>
      <p class="m-0 body-1">Ce que {{ data.member.fullName }} a déjà traité reste dans l'historique.</p>
    </div>
  </div>

  <div class="rounded bg-gray-light px-3 py-2 flex items-center gap-3">
    <mat-icon class="text-secondary">groups</mat-icon>
    <span class="body-1">
      {{ data.team.name }} : {{ remainingCount }} membre{{ remainingCount > 1 ? 's' : '' }} après le retrait
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">ANNULER</button>
  <button mat-raised-button color="warn" type="button" (click)="close()">RETIRER</button>
</mat-dialog-actions>
